import { render, staticRenderFns } from "./ProductsFilterMobile.vue?vue&type=template&id=b23f7744&scoped=true&"
import script from "./ProductsFilterMobile.vue?vue&type=script&lang=js&"
export * from "./ProductsFilterMobile.vue?vue&type=script&lang=js&"
import style0 from "./ProductsFilterMobile.vue?vue&type=style&index=0&id=b23f7744&scoped=true&lang=css&"
import style1 from "./ProductsFilterMobile.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b23f7744",
  null
  
)

export default component.exports